import React from 'react';
import Tabs from '../../tabs';
import Detail from './list';

export default ({data, id, direction}) => {
    return (
        <div style={{display:'flex', flexDirection:'column'}}>
            <Tabs 
                selTab={2}
                tabs={[
                    {
                        id:0,
                        caption:'detail',
                        href:`/flight/schedule/${direction}/${id}`,
                    },
                    {
                        id:1,
                        caption:'pnr',
                        href:`/flight/schedule/${direction}/pnr/${id}`,
                    },
                    {
                        id:2, 
                        caption:'passengers',
                        href:`/flight/schedule/${direction}/passengers/${id}`,
                    }
                ]}
            />
            <Detail data={data}  />
        </div>
    )
}